export default "__VITE_ASSET__D020KTY$__"